export const THICKNESS = 10;

export const FADE_SIZE = 40;

export const PADDING = 2;

export const THIN_PADDING = 3;

export const SCROLL_AREA_TAG_NAME = "scroll-area" as const;

export const SCROLL_AREA_FADES = ["true", "false", "start", "end"] as const;
